import { ShieldCheck } from "lucide-react";

const items = [
  "Radon Testing",
  "Sub-Slab Mitigation",
  "Real Estate Closings",
  "Licensed & Insured",
  "Greater Boston & MetroWest",
  "Free Quotes",
  "Established 2018",
];

export default function Marquee() {
  return (
    <section
      data-testid="stats-marquee"
      aria-label="Company highlights"
      className="marquee-track overflow-hidden bg-navy py-5"
    >
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {[...items, ...items].map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center gap-10 whitespace-nowrap font-mono text-sm uppercase tracking-[0.22em] text-white/80"
          >
            {item}
            <ShieldCheck className="h-4 w-4 text-gold" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
}
